import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Container,
  Dialog,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Modal,
  Typography,
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import TopNav from '../TopNav/TopNav';
import { getCompanySuppliersAction } from './Action';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  decodeToken,
  newSecondaryIndustryTypeArr,
  SupplierModuleTypeEnum,
} from '../../utils/settings';
import { GetCompanyDetailsByPhoneNumber } from '../../screen/distributor/action/util_action';

import dayjs from 'dayjs';
import { ArrowBack } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function POSelectIndustry() {
  const [selectedSubIndustryId, setSelectedSubIndustryId] = useState(null);
  const [subIndustryDetails, setSubIndustryDetails] = useState({});
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [mapData, setMapData] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [distributorsList, setDistributorsList] = useState([]);
  const [openDistributorDialog, setOpenDistributorDialog] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState({});
  const [isSecondaryOrder, setIsSecondaryOrder] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getCompany = async (isSecondary, subIndustryId) => {
    const params = new URLSearchParams();

    if (isSecondaryOrder || isSecondary) {
      params.append('supplier_id', subIndustryDetails.id || subIndustryId);
    }

    const { data, error, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.po_enabled,
      params,
    );

    if (!error) {
      if (isSecondaryOrder || isSecondary) {
        setDistributorsList(data[0].suppliers_list);
        setOpenDistributorDialog(true);
      } else {
        setSuppliersList(data);
        setMapData(data);
      }
    } else {
      toast.error(message);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  useEffect(() => {
    if (selectedSubIndustryId === null) {
      setMapData(suppliersList);
      return;
    }
    // const data = mapData.filter((item) => item.sub_industry_id === selectedSubIndustryId);
    setMapData(subIndustryDetails.suppliers_list);
  }, [selectedSubIndustryId]);

  const addSelf = async ({ distributorDetails, secondary_order = false }) => {
    const decoded = await decodeToken();
    let params = new URLSearchParams();
    params.append('supplier_id', Number(subIndustryDetails.id));
    const { error, message, data } = await GetCompanyDetailsByPhoneNumber(
      decoded.phone_number,
      params,
    );

    if (!error) {
      const foundCo = data.company_details.find(
        (co) => co.id == decoded.default_company_info.company_id,
      );

      if (foundCo) {
        const userObj = {
          delivery_Address_line1:
            foundCo.geographic_info.address_info.address_line_1,
          delivery_Address_line2:
            foundCo.geographic_info.address_info.address_line_2,
          delivery_Address_line3:
            foundCo.geographic_info.address_info.address_line_3,
          delivery_company_pincode:
            foundCo.geographic_info.pincode_info.pincode_id,
          delivery_location_id:
            foundCo.geographic_info.location_info.location_id,
          delivery_location_name:
            foundCo.geographic_info.location_info.location_name,
          delivery_pricing_geography_id:
            foundCo.geographic_info.pricing_geography_info.pricing_geography_id,
          delivery_pricing_geography_name:
            foundCo.geographic_info.pricing_geography_info
              .pricing_geography_name,
          company_address1: foundCo.geographic_info.address_info.address_line_1,
          company_address2: foundCo.geographic_info.address_info.address_line_2,
          company_address3: foundCo.geographic_info.address_info.address_line_3,
          company_pincode: foundCo.geographic_info.pincode_info.pincode_id,
          location_id: foundCo.geographic_info.location_info.location_id,
          location_name: foundCo.geographic_info.location_info.location_name,
          pricing_geography_id:
            foundCo.geographic_info.pricing_geography_info.pricing_geography_id,
          pricing_geography_name:
            foundCo.geographic_info.pricing_geography_info
              .pricing_geography_name,
          company_id: foundCo.id,
          company_name: foundCo.name,
          company_phone_no: decoded.phone_number,
          company_type: foundCo.company_type,
          delivery_district_id:
            foundCo.geographic_info.district_info.district_id,
          dispatch_date: dayjs(),
          district_id: foundCo.geographic_info.district_info.district_id,
          gstin: foundCo.gstin,
          pancard_no: foundCo.pancard_no,
          state_id: foundCo.geographic_info.state_info.state_id,
        };
        dispatch({
          type: 'SET_USER_LIST',
          data: [userObj],
        });

        dispatch({
          type: 'SET_SUPPLIER_ID', //distributor id
          data: distributorDetails,
        });
        navigate('/order-booking/selected-ship-to-party-list');
      }
    } else {
      return toast.error('Something went wrong');
    }
  };

  const handleDistributorClick = (distributor) => {
    setSelectedDistributor(distributor);
    if (subIndustryDetails.po_config.as_seller.required) {
      dispatch({
        type: 'SET_IS_PAINT_FLOW',
        data: false,
      });
    } else {
      dispatch({
        type: 'SET_IS_PAINT_FLOW',
        data: true,
      });
    }
    addSelf({
      distributorDetails: distributor,
    });
    setOpenDistributorDialog(false);
  };
  useEffect(() => {
    dispatch({ type: 'RESET_FMCG_REDUCER' });
    dispatch({ type: 'CLEAR_RETAILERS' });
    dispatch({ type: 'RESET_BCM_ORDER' });
  }, []);
  return (
    <Container
      maxWidth='true'
      sx={{
        pl: '2rem',
        pt: '2rem',
        height: window.innerHeight,
        overflowY: 'auto',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Typography
        variant='h5'
        style={{ marginBottom: '2rem', fontWeight: 'bold' }}
      >
        Po/Order Booking
      </Typography>
      <Box
        sx={{
          bgcolor: '#ffffff',
          borderRadius: '10px',
          p: '2rem',
        }}
      >
        {selectedSubIndustryId && (
          <IconButton
            sx={{ display: 'flex', justifyContent: 'center' }}
            onClick={() => {
              setSelectedSubIndustryId(null);
            }}
          >
            <ArrowBack
              color={'primary'}
              fontSize='large'
              sx={{ mb: '2rem' }}
            />
          </IconButton>
        )}
        <Grid
          container
          spacing={2}
        >
          {mapData &&
            mapData.length > 0 &&
            mapData.map((item) => {
              return (
                <Grid
                  item
                  xs={3}
                >
                  <Card
                    sx={{
                      width: '15rem',
                      height: '19rem',
                      borderRadius: 5,
                    }}
                  >
                    <CardActionArea
                      sx={{
                        width: '15rem',
                        height: '19rem',
                        //   borderRadius: 5,
                      }}
                      onClick={() => {
                        if (selectedSubIndustryId) {
                          dispatch({
                            type: 'SET_SELLER_ID',
                            data: item.id,
                          });

                          dispatch({
                            type: 'STORE_COMPANY_DETAILS',
                            companyDetails: item,
                          });

                          if (item.is_secondary_supplier_required) {
                            dispatch({
                              type: 'IS_SECONDARY_ORDER',
                              data: true,
                            });
                            setIsSecondaryOrder(true);
                            setSubIndustryDetails(item);
                            getCompany(true, item.id);
                          } else {
                            if (
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr['FOOD'] ||
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr['PERSONAL_HYGIENE']
                            ) {
                              // addSelf({
                              //   distributor_id: item.id,
                              // });
                              dispatch({
                                type: 'SET_IS_FMCG_FLOW',
                                data: true,
                              });

                              dispatch({
                                type: 'SET_IS_PAINT_FLOW',
                                data: true,
                              });
                              dispatch({
                                type: 'STORE_COMPANY_DETAILS',
                                companyDetails: item,
                              });

                              navigate('/order-booking/product-list', {
                                state: {
                                  distributor_id: item.id,
                                },
                              });
                            } else if (
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr[
                                  'PAINT_AND_HARDWARE'
                                ] ||
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr['CEMENT']
                            ) {
                              dispatch({
                                type: 'STORE_COMPANY_DETAILS',
                                companyDetails: item,
                              });
                              dispatch({
                                type: 'SET_IS_PAINT_FLOW',
                                data: true,
                              });
                              dispatch({
                                type: 'SET_IS_FMCG_FLOW',
                                data: false,
                              });
                              dispatch({
                                type: 'IS_SECONDARY_ORDER',
                                data: item.is_secondary_supplier_required,
                              });

                              navigate('/order-booking/product-list', {
                                state: {
                                  distributor_id: item.id,
                                },
                              });
                            } else if (
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr['TMT'] ||
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr['ANGLES'] ||
                              selectedSubIndustryId ===
                                newSecondaryIndustryTypeArr['ERW']
                            ) {
                              dispatch({
                                type: 'SET_IS_PAINT_FLOW',
                                data: false,
                              });
                              setSubIndustryDetails(item);
                              setOpen(true);
                            }
                          }
                        } else {
                          setSelectedSubIndustryId(item.sub_industry_id);
                          setSubIndustryDetails(item);
                        }
                      }}
                    >
                      <img
                        style={{
                          width: '15rem',
                          height: '15rem',
                          // borderRadius: 5,
                        }}
                        src={
                          item.sub_industry_logo
                            ? item.sub_industry_logo
                            : item.logo
                        }
                        alt={item.sub_industry_name}
                      />
                      <CardContent
                        sx={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <Typography
                          gutterBottom
                          variant='subtitle1'
                          component={'div'}
                          style={{ fontWeight: 'bold' }}
                        >
                          {selectedSubIndustryId
                            ? item?.name
                            : item.sub_industry_name}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 380,
            bgcolor: 'background.paper',
            borderRadius: 5,

            boxShadow: 24,
            p: 4,
            justifyContent: 'center',
            alignContent: 'center',
          }}
        >
          <Button
            variant='contained'
            style={{
              fontWeight: 'bold',
            }}
            fullWidth
            onClick={() =>
              navigate('/order-booking/po-booking', {
                state: {
                  seller_info: subIndustryDetails,
                },
              })
            }
          >
            Create a new Purchase order
          </Button>
          <Typography
            id='modal-modal-title'
            variant='h6'
            component='h2'
            sx={{
              fontWeight: 'bold',
              color: '#000000',
              marginTop: '2rem',
              marginBottom: '2rem',
              textAlign: 'center',
            }}
          >
            Or
          </Typography>
          <Button
            variant='outlined'
            style={{
              fontWeight: 'bold',
            }}
            fullWidth
            onClick={() =>
              navigate('/order-booking/po-list', {
                state: { companyId: subIndustryDetails?.id },
              })
            }
          >
            View Existing Purchase orders
          </Button>
        </Box>
      </Modal>
      <DistributorDialog
        open={openDistributorDialog}
        distributorsList={distributorsList}
        handleDistributorClick={(distributor) =>
          handleDistributorClick(distributor)
        }
        onClose={() => setOpenDistributorDialog(false)}
      />
    </Container>
  );
}

const DistributorDialog = ({
  open = false,
  handleDistributorClick = () => {},
  distributorsList = [],
  onClose = () => {},
}) => {
  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
    >
      <DialogTitle>Select Distributor</DialogTitle>
      <List>
        {distributorsList.map((distributor) => {
          return (
            <ListItem
              disableGutters
              key={distributor.id}
            >
              <ListItemButton
                variant='text'
                onClick={() => {
                  handleDistributorClick(distributor);
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                    <PersonIcon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={distributor.name} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Dialog>
  );
};

export default POSelectIndustry;
